(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-catalog-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-catalog-filters')) {
  customElements.define('bc-catalog-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = new URL(link.href);
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (key === 'sort_by' || key.startsWith('filter.') || key === 'preview_theme_id') target.searchParams.append(key, value);
        });
        event.preventDefault();
        window.location.assign(target.href);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
